import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'om-scribe-consent-modal',
  templateUrl: './scribe-consent-modal.component.html',
  styleUrls: ['./scribe-consent-modal.component.scss'],
})
export class ScribeConsentModalComponent {
  @Output() selection = new EventEmitter<boolean>();

  constructor() {}

  handleSelection(selection: boolean) {
    this.selection.emit(selection);
  }
}
